<div class="message-container">
<div class="lock"></div>
<div class="message">
  <h1>Access to this page is restricted!</h1>
</div>
